import { useTranslation } from "utils";

/** Wraps a formatted figure in the "about …" qualifier the onboarding outcome figures share. */
export const useApproxValue = () => {
  const { t } = useTranslation("scenarioAnalysis");

  return (value: string) => t("onboarding.approxValue", { value });
};
